import CompanyFields from './CompanyFields'

export default CompanyFields
